// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { GenericLayerProperties } from "./GenericLayerProperties";
import {
  instanceOfGenericLayerProperties,
  GenericLayerPropertiesFromJSON,
  GenericLayerPropertiesFromJSONTyped,
  GenericLayerPropertiesToJSON,
} from "./GenericLayerProperties";
import type { RasterLayerProperties } from "./RasterLayerProperties";
import {
  instanceOfRasterLayerProperties,
  RasterLayerPropertiesFromJSON,
  RasterLayerPropertiesFromJSONTyped,
  RasterLayerPropertiesToJSON,
} from "./RasterLayerProperties";

/**
 * @type LayerInputProperties
 *
 * @export
 */
export type LayerInputProperties =
  | ({ type: "generic" } & GenericLayerProperties)
  | ({ type: "raster" } & RasterLayerProperties);

export function LayerInputPropertiesFromJSON(json: any): LayerInputProperties {
  return LayerInputPropertiesFromJSONTyped(json, false);
}

export function LayerInputPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LayerInputProperties {
  if (json == null) {
    return json;
  }
  switch (json["type"]) {
    case "generic":
      return Object.assign({}, GenericLayerPropertiesFromJSONTyped(json, true), {
        type: "generic",
      } as const);
    case "raster":
      return Object.assign({}, RasterLayerPropertiesFromJSONTyped(json, true), {
        type: "raster",
      } as const);
    default:
      return json;
  }
}

export function LayerInputPropertiesToJSON(json: any): any {
  return LayerInputPropertiesToJSONTyped(json, false);
}

export function LayerInputPropertiesToJSONTyped(
  value?: LayerInputProperties | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  switch (value["type"]) {
    case "generic":
      return Object.assign({}, GenericLayerPropertiesToJSON(value), { type: "generic" } as const);
    case "raster":
      return Object.assign({}, RasterLayerPropertiesToJSON(value), { type: "raster" } as const);
    default:
      return value;
  }
}
